// Module
var code = `<div class="denomination" ng-show="\$ctrl.supportsDenomination">

  <div class="denomination-grid-wrap">

    <div class="denomination-grid-na disabled-text" ng-if="!\$ctrl.incomingEnabled">
      <h2>N/A</h2>
    </div>
    <div ng-if="\$ctrl.incomingEnabled === true">
      <p class="denomination-grid-title"><strong>CASH IN</strong> (total: {{ \$ctrl.bundle.incoming.totalValue | nxCurrency:{currency:\$ctrl.currency.isoCode} }})</p>
      <div class="denomination-grid">
        <!-- Each column contains N denomination rows -->
        <div ng-repeat="column in \$ctrl.bundle.incoming.grid.columns" class="column-wrapper">
          <table class="table">
            <thead>
            <th></th>
            <th></th>
            </thead>
            <tbody>
            <tr ng-repeat="unit in column track by \$index">
              <td class="unit-name">
                {{ unit.subunit ? (unit.unitValue / 100).toFixed(2) : unit.unitValue }} <span class="disabled-text">{{ \$ctrl.currency.isoCode }}</span>
              </td>
              <td>
                <input
                  type="number"
                  ng-disabled="\$ctrl.readOnly"
                  ng-model="\$ctrl.bundle.incoming.grid.units[unit.id].count"
                  ng-change="\$ctrl.onDenominationCountChange(\$ctrl.bundle.incoming, unit.id)"
                  min="0"
                  max="999999"/>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="grid-separator">&nbsp;</div>

  <div class="denomination-grid-wrap">

    <div class="denomination-grid-na disabled-text" ng-if="!\$ctrl.outgoingEnabled">
      <h2>N/A</h2>
    </div>

    <div ng-if="\$ctrl.outgoingEnabled === true">
      <p class="denomination-grid-title"><strong>CASH OUT</strong> (total: {{ \$ctrl.bundle.outgoing.totalValue | nxCurrency:{currency:\$ctrl.currency.isoCode} }})</p>
      <div class="denomination-grid">
        <!-- Each column contains N denomination rows -->
        <div ng-repeat="column in \$ctrl.bundle.outgoing.grid.columns" class="column-wrapper">
          <table class="table">
            <thead>
            <th></th>
            <th></th>
            </thead>
            <tbody>
            <tr ng-repeat="unit in column track by \$index">
              <td class="unit-name">
                {{ unit.subunit ? (unit.unitValue / 100).toFixed(2) : unit.unitValue }} <span class="disabled-text">{{ \$ctrl.currency.isoCode }}</span>
              </td>
              <td>
                <input
                  type="number"
                  ng-disabled="\$ctrl.readOnly"
                  ng-model="\$ctrl.bundle.outgoing.grid.units[unit.id].count"
                  ng-change="\$ctrl.onDenominationCountChange(\$ctrl.bundle.outgoing, unit.id)"
                  min="0"
                  max="999999"/>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="clearfix"></div>

  <div class="denomination-footer">
    <p ng-class="{'error': !\$ctrl.valid}">
      Total: {{ \$ctrl.bundle.totalValue | nxCurrency:{currency:\$ctrl.currency.isoCode} }}<span ng-if="\$ctrl.overdraftValue > 0">&nbsp;|&nbsp;{{ \$ctrl.overdraftLabel }}: {{ \$ctrl.overdraftValue | nxCurrency:{currency:\$ctrl.currency.isoCode} }}</span>
    </p>
    <div ng-if="\$ctrl.overdraftValue > 0">
      <input id="allowDifference"
             ng-change="\$ctrl.onAllowOverdraftChange()"
             ng-model="\$ctrl.allowOverdraft"
             ng-disabled="\$ctrl.overdraftThreshold <= \$ctrl.overdraftValue"
             type="checkbox"/>
      <label for="allowDifference" ng-class="{'disabled-text': \$ctrl.overdraftThreshold <= \$ctrl.overdraftValue}">
        I want to proceed with {{\$ctrl.overdraftLabel | lowercase}} (max allowed {{\$ctrl.overdraftThreshold | nxCurrency:{currency:\$ctrl.currency.isoCode} }})
      </label>
    </div>
  </div>

  <div class="clearfix"></div>

</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/denomination/denomination.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;